module.exports = __webpack_public_path__ + "static/media/super_elephant.skywind.6bbead23.jpeg";